import { FilterMatchMode } from "primereact/api";

export class Inmueble {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            tipo_bien: {
                value: null,
                export: false,
                table: true,
                header: 'Tipo de Bien:',
                required: 'Tipo de Bien es requerido',
                matchMode: FilterMatchMode.CONTAINS,
            },
            otro_bien: {
                value: '',
                export: false,
                table: false,
                header: 'Otro Bien:',
                required: 'Otro Bien es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            pais: {
                value: null,
                export: false,
                table: false,
                header: 'País:',
                required: 'País es requerido',
            },
            provincia: {
                value: null,
                export: false,
                table: false,
                header: 'Provincia:',
                required: 'Provincia es requerida',
            },
            ciudad: {
                value: null,
                export: false,
                table: false,
                header: 'Ciudad:',
                required: 'Ciudad es requerida',
            },
            canton: {
                value: '',
                export: false,
                table: false,
                header: 'Ciudad / Cantón:',
                required: 'Ciudad es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            direccion: {
                value: '',
                export: false,
                table: true,
                sort: false,
                filter: true,
                filterPlaceholder: 'Buscar dirección',
                filterField: 'direccion',
                header: 'DIRECCIÓN:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            fecha_adquisicion: {
                value: new Date(),
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'FECHA ADQUISICIÓN:',
                required: 'Fecha requerida',
            },
            fecha_registro_propiedad: {
                value: new Date(),
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'INSCRIPCIÓN EN REGISTRO DE LA PROPIEDAD:',
                required: 'Fecha requerida',
            },
            numero_predio_referencia: {
                value: '',
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'NÚMERO DE PREDIO DE REFERENCIA:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            valor_bien: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'VALOR DEL BIEN USD:',
                required: 'Valor del bien es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
